import type { DocumentFlagProjection, Flag } from '~/shared/api/data-ingestion-api/client'

import { isFlagNote } from './flag-severity'
import { getPendingFlags } from './get-pending-flags'

export function groupFlagsBySeverity<T extends Flag | DocumentFlagProjection>(
  flags: T[],
): {
  note: T[]
  attention: T[]
} {
  const pending = getPendingFlags(flags)
  const note: T[] = []
  const attention: T[] = []

  for (const flag of pending) {
    if (isFlagNote(flag)) {
      note.push(flag)
    } else {
      attention.push(flag)
    }
  }

  return { note, attention }
}
